var L = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function V(i) {
  if (i.__esModule) return i;
  var f = i.default;
  if (typeof f == "function") {
    var c = function o() {
      return this instanceof o ? Reflect.construct(f, arguments, this.constructor) : f.apply(this, arguments);
    };
    c.prototype = f.prototype;
  } else c = {};
  return Object.defineProperty(c, "__esModule", { value: !0 }), Object.keys(i).forEach(function(o) {
    var E = Object.getOwnPropertyDescriptor(i, o);
    Object.defineProperty(c, o, E.get ? E : {
      enumerable: !0,
      get: function() {
        return i[o];
      }
    });
  }), c;
}
var X = { exports: {} };
function k(i) {
  throw new Error('Could not dynamically require "' + i + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var H = { exports: {} };
const z = {}, j = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z
}, Symbol.toStringTag, { value: "Module" })), $ = /* @__PURE__ */ V(j);
var Y;
function G() {
  return Y || (Y = 1, function(i, f) {
    (function(c, o) {
      i.exports = o();
    })(L, function() {
      var c = c || function(o, E) {
        var l;
        if (typeof window < "u" && window.crypto && (l = window.crypto), typeof self < "u" && self.crypto && (l = self.crypto), typeof globalThis < "u" && globalThis.crypto && (l = globalThis.crypto), !l && typeof window < "u" && window.msCrypto && (l = window.msCrypto), !l && typeof L < "u" && L.crypto && (l = L.crypto), !l && typeof k == "function")
          try {
            l = $;
          } catch {
          }
        var U = function() {
          if (l) {
            if (typeof l.getRandomValues == "function")
              try {
                return l.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof l.randomBytes == "function")
              try {
                return l.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, R = Object.create || /* @__PURE__ */ function() {
          function t() {
          }
          return function(n) {
            var e;
            return t.prototype = n, e = new t(), t.prototype = null, e;
          };
        }(), S = {}, T = S.lib = {}, v = T.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(t) {
              var n = R(this);
              return t && n.mixIn(t), (!n.hasOwnProperty("init") || this.init === n.init) && (n.init = function() {
                n.$super.init.apply(this, arguments);
              }), n.init.prototype = n, n.$super = this, n;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var t = this.extend();
              return t.init.apply(t, arguments), t;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(t) {
              for (var n in t)
                t.hasOwnProperty(n) && (this[n] = t[n]);
              t.hasOwnProperty("toString") && (this.toString = t.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), d = T.WordArray = v.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(t, n) {
            t = this.words = t || [], n != E ? this.sigBytes = n : this.sigBytes = t.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(t) {
            return (t || P).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(t) {
            var n = this.words, e = t.words, s = this.sigBytes, _ = t.sigBytes;
            if (this.clamp(), s % 4)
              for (var u = 0; u < _; u++) {
                var p = e[u >>> 2] >>> 24 - u % 4 * 8 & 255;
                n[s + u >>> 2] |= p << 24 - (s + u) % 4 * 8;
              }
            else
              for (var I = 0; I < _; I += 4)
                n[s + I >>> 2] = e[I >>> 2];
            return this.sigBytes += _, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var t = this.words, n = this.sigBytes;
            t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = o.ceil(n / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var t = v.clone.call(this);
            return t.words = this.words.slice(0), t;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(t) {
            for (var n = [], e = 0; e < t; e += 4)
              n.push(U());
            return new d.init(n, t);
          }
        }), y = S.enc = {}, P = y.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(t) {
            for (var n = t.words, e = t.sigBytes, s = [], _ = 0; _ < e; _++) {
              var u = n[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
              s.push((u >>> 4).toString(16)), s.push((u & 15).toString(16));
            }
            return s.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(t) {
            for (var n = t.length, e = [], s = 0; s < n; s += 2)
              e[s >>> 3] |= parseInt(t.substr(s, 2), 16) << 24 - s % 8 * 4;
            return new d.init(e, n / 2);
          }
        }, A = y.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(t) {
            for (var n = t.words, e = t.sigBytes, s = [], _ = 0; _ < e; _++) {
              var u = n[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
              s.push(String.fromCharCode(u));
            }
            return s.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(t) {
            for (var n = t.length, e = [], s = 0; s < n; s++)
              e[s >>> 2] |= (t.charCodeAt(s) & 255) << 24 - s % 4 * 8;
            return new d.init(e, n);
          }
        }, r = y.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(t) {
            try {
              return decodeURIComponent(escape(A.stringify(t)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(t) {
            return A.parse(unescape(encodeURIComponent(t)));
          }
        }, a = T.BufferedBlockAlgorithm = v.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new d.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(t) {
            typeof t == "string" && (t = r.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(t) {
            var n, e = this._data, s = e.words, _ = e.sigBytes, u = this.blockSize, p = u * 4, I = _ / p;
            t ? I = o.ceil(I) : I = o.max((I | 0) - this._minBufferSize, 0);
            var N = I * u, O = o.min(N * 4, _);
            if (N) {
              for (var g = 0; g < N; g += u)
                this._doProcessBlock(s, g);
              n = s.splice(0, N), e.sigBytes -= O;
            }
            return new d.init(n, O);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var t = v.clone.call(this);
            return t._data = this._data.clone(), t;
          },
          _minBufferSize: 0
        });
        T.Hasher = a.extend({
          /**
           * Configuration options.
           */
          cfg: v.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(t) {
            this.cfg = this.cfg.extend(t), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            a.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(t) {
            return this._append(t), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(t) {
            t && this._append(t);
            var n = this._doFinalize();
            return n;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(t) {
            return function(n, e) {
              return new t.init(e).finalize(n);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(t) {
            return function(n, e) {
              return new h.HMAC.init(t, e).finalize(n);
            };
          }
        });
        var h = S.algo = {};
        return S;
      }(Math);
      return c;
    });
  }(H)), H.exports;
}
(function(i, f) {
  (function(c, o) {
    i.exports = o(G());
  })(L, function(c) {
    return c.enc.Hex;
  });
})(X);
var q = { exports: {} };
(function(i, f) {
  (function(c, o) {
    i.exports = o(G());
  })(L, function(c) {
    return function(o) {
      var E = c, l = E.lib, U = l.WordArray, R = l.Hasher, S = E.algo, T = [], v = [];
      (function() {
        function P(h) {
          for (var t = o.sqrt(h), n = 2; n <= t; n++)
            if (!(h % n))
              return !1;
          return !0;
        }
        function A(h) {
          return (h - (h | 0)) * 4294967296 | 0;
        }
        for (var r = 2, a = 0; a < 64; )
          P(r) && (a < 8 && (T[a] = A(o.pow(r, 1 / 2))), v[a] = A(o.pow(r, 1 / 3)), a++), r++;
      })();
      var d = [], y = S.SHA256 = R.extend({
        _doReset: function() {
          this._hash = new U.init(T.slice(0));
        },
        _doProcessBlock: function(P, A) {
          for (var r = this._hash.words, a = r[0], h = r[1], t = r[2], n = r[3], e = r[4], s = r[5], _ = r[6], u = r[7], p = 0; p < 64; p++) {
            if (p < 16)
              d[p] = P[A + p] | 0;
            else {
              var I = d[p - 15], N = (I << 25 | I >>> 7) ^ (I << 14 | I >>> 18) ^ I >>> 3, O = d[p - 2], g = (O << 15 | O >>> 17) ^ (O << 13 | O >>> 19) ^ O >>> 10;
              d[p] = N + d[p - 7] + g + d[p - 16];
            }
            var F = e & s ^ ~e & _, W = a & h ^ a & t ^ h & t, x = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22), K = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25), D = u + K + F + v[p] + d[p], M = x + W;
            u = _, _ = s, s = e, e = n + D | 0, n = t, t = h, h = a, a = D + M | 0;
          }
          r[0] = r[0] + a | 0, r[1] = r[1] + h | 0, r[2] = r[2] + t | 0, r[3] = r[3] + n | 0, r[4] = r[4] + e | 0, r[5] = r[5] + s | 0, r[6] = r[6] + _ | 0, r[7] = r[7] + u | 0;
        },
        _doFinalize: function() {
          var P = this._data, A = P.words, r = this._nDataBytes * 8, a = P.sigBytes * 8;
          return A[a >>> 5] |= 128 << 24 - a % 32, A[(a + 64 >>> 9 << 4) + 14] = o.floor(r / 4294967296), A[(a + 64 >>> 9 << 4) + 15] = r, P.sigBytes = A.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var P = R.clone.call(this);
          return P._hash = this._hash.clone(), P;
        }
      });
      E.SHA256 = R._createHelper(y), E.HmacSHA256 = R._createHmacHelper(y);
    }(Math), c.SHA256;
  });
})(q);
const J = (i, f, c) => c === "subflow" ? "https://subflow.beta.petplate.com" : "https://beta.petplate.com", Q = (i, f, c, o) => {
  const E = "beta";
  return o ? `https://${i}-${c}-${E}-${o}.herokuapp.com` : `https://${i}-${c}-${E}.herokuapp.com`;
}, w = (i, f, c, o, E) => [Q(i, f, c, o), E].filter((l) => l).join(":"), b = (i, f, c, o) => [J(i, f, c), o].filter((E) => E).join(":"), Z = (i) => `https://${i}`, tt = (i, f) => f, nt = (i, f) => {
  var o;
  return `https://admin.shopify.com/store/${(o = i == null ? void 0 : i.split(".")) == null ? void 0 : o[0]}/apps/${f}`;
}, B = "platform", C = "localhost", lt = "production", ut = "beta", ft = "beta", Et = "", pt = process.env.HEROKU_PR_NUMBER, It = null, et = null, dt = null, ht = "staging", rt = null, ot = null, st = null, it = null, Pt = null, ct = null, At = null, vt = !1, Ot = null, Tt = null, Rt = null, St = null, yt = null, Nt = null, Lt = null, gt = null, Bt = null, Ct = "GfTq8v8hwzxo7wHOAL1IqORPGbsJUXF8nJspLEGV", Ut = null, Ht = null, wt = null, m = "petplate-development.myshopify.com", Dt = "57d58aeb7a1462c49629a3ed586f8b3f", Yt = "2025-01", Gt = "GTM-KJNPGK2C", bt = "G-ZVE7PQY67W", mt = null, Ft = "https://rdsgb.petplate.com", Wt = !1, xt = null, Kt = "2025-01", Mt = "US", Vt = "EN", Xt = Z(m), kt = null, zt = null, at = null, jt = "gid://shopify/ProductVariant/47547713847458", $t = "gid://shopify/ProductVariant/47547713978530", qt = null, Jt = process.env.NEXT_PUBLIC_SHOW_V9_PRICE_CHANGE, Qt = null, Zt = null, tn = "9e0964421a455ca62fa4fffa48767b35f930635ed143e4b9f3030e3a39b14f57", nn = "javascript-nextjs", en = "petplate", rn = null, on = null, sn = "6Lf8KJopAAAAAHp6VMFsFjOjEy9m0NLsIkG-llH3", cn = "6Lf8KJopAAAAAIW99HnsO7Kz2zMmFU9sV9zpKwRi", an = !1, _n = process.env.SKIP_SUBFLOW_CALCULATING_STEP === "true", ln = w(
  B,
  C,
  "cms",
  process.env.ADMIN_APP_SUFFIX,
  rt
), _t = w(
  B,
  C,
  "api",
  process.env.API_APP_SUFFIX,
  et
), un = w(
  B,
  C,
  "graphql",
  process.env.GRAPHQL_APP_SUFFIX,
  it
), fn = b(B, C, "web", ot), En = b(B, C, "subflow", st), pn = tt(ct, _t), In = nt(m, at);
export {
  rt as ADMIN_PORT,
  ln as ADMIN_URL,
  ct as API_NGROK_HOST,
  et as API_PORT,
  _t as API_URL,
  jt as BUNDLE_PARENT_VARIANT_GID,
  an as DISABLE_CAPTCHA,
  ut as DOMAIN_PREFIX,
  Ft as EDGETAG_EDGE_URL,
  lt as ENV,
  bt as GOOGLE_ANALYTICS_MEASUREMENT_ID,
  cn as GOOGLE_RECAPTCHA_SECRET_KEY,
  it as GRAPHQL_PORT,
  un as GRAPHQL_URL,
  Gt as GTM_CONTAINER_ID,
  It as HEROKU_BRANCH,
  pt as HEROKU_PR_NUMBER,
  Ot as KLAVIYO_API_KEY,
  xt as KLAVIYO_SITE_ID,
  dt as MAINTENANCE_MODE,
  mt as MIXPANEL_TOKEN,
  Pt as MONGODB_URI,
  wt as NEXT_PUBLIC_AISLE_WIDGET_ID,
  ht as NEXT_PUBLIC_CLIENT_WEBHOOK_NAMESPACE,
  sn as NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
  Tt as NEXT_PUBLIC_KLAVIYO_API_KEY,
  Qt as NEXT_PUBLIC_SENTRY_DSN,
  Ht as NEXT_PUBLIC_STOREPOINT_MAP_ID,
  Ct as NEXT_PUBLIC_YOTPO_APP_KEY,
  St as NEXT_PUBLIC_YOTPO_LOYALTY_JS_SDK_ID,
  Rt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_BANNER_WIDGET_ID,
  Nt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_EARNING_POINTS_WIDGET_ID,
  yt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_MY_ACTIVITY_WIDGET_ID,
  Lt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_REDEEM_POINTS_WIDGET_ID,
  gt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_REFER_FRIENDS_WIDGET_ID,
  Bt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_VIP_TIERS_WIDGET_ID,
  Ut as NEXT_PUBLIC_YOTPO_REFER_A_FRIEND_PAGE_WIDGET_ID,
  rn as SENDGRID_API_KEY,
  on as SENDGRID_DOMAIN,
  tn as SENTRY_AUTH_TOKEN,
  Zt as SENTRY_DSN,
  en as SENTRY_ORG,
  nn as SENTRY_PROJECT,
  In as SHOPIFY_ADMIN_URL,
  At as SHOPIFY_API_KEY,
  Yt as SHOPIFY_API_VERSION,
  zt as SHOPIFY_APP_NAME,
  at as SHOPIFY_APP_NS,
  Mt as SHOPIFY_COUNTRY_ISO_CODE,
  m as SHOPIFY_CUSTOM_DOMAIN,
  vt as SHOPIFY_DEV_SIDENAV,
  Vt as SHOPIFY_LANGUAGE_ISO_CODE,
  Dt as SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  Kt as SHOPIFY_STOREFRONT_API_VERSION,
  Xt as SHOPIFY_URL,
  qt as SHOW_PRICE_CHANGE_FEATURE,
  Jt as SHOW_V9_PRICE_CHANGE,
  _n as SKIP_SUBFLOW_CALCULATING_STEP,
  kt as STRIPE_PUBLISHABLE_KEY,
  st as SUBFLOW_PORT,
  En as SUBFLOW_URL,
  $t as SUBSCRIPTION_CARRIER_VARIANT_GID,
  Wt as TRIPLE_WHALE_ENABLED,
  ft as VERCEL_GIT_COMMIT_REF,
  Et as VERCEL_GIT_PULL_REQUEST_ID,
  pn as WEBHOOK_URL,
  ot as WEB_PORT,
  fn as WEB_URL
};
